<template>
  <div>
    <el-table :data="projects" default-expand-all>
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="scale" label="精度"></el-table-column>
      <el-table-column prop="maxAmount" label="最大认购数量"></el-table-column>
      <el-table-column prop="minAmount" label="最小认购数量"></el-table-column>
      <el-table-column prop="buyRate" label="购买率（%）"></el-table-column>
      <el-table-column prop="depositAmount" label="已存入数量"></el-table-column>
      <el-table-column prop="rate" label="预计年化收益（%）"></el-table-column>
      <el-table-column label="发布状态">
        <template slot-scope="scope">
         <span v-if="scope.row.status==0">隐藏</span>
         <span v-else>开启</span>
          </template>
      </el-table-column>
      <!-- <el-table-column
        prop="distributionCoinType"
        label="发放币种"
      ></el-table-column>
      <el-table-column prop="distributionAccount" label="平台账户">
        <template slot-scope="scope">
          <a @click="getUserDetail(scope.row.distributionAccount)">{{
            scope.row.distributionAccount
          }}</a>
        </template>
      </el-table-column>

      <el-table-column label="直推奖励">
        <template slot-scope="scope"
          >{{ scope.row.firstInviteRate * 100 }}%</template
        >
      </el-table-column>
      <el-table-column label="间推奖励">
        <template slot-scope="scope"
          >{{ scope.row.secondInviteRate * 100 }}%</template
        >
      </el-table-column>
      <el-table-column
        prop="nextInterestAmount"
        label="预计下次发放利息"
      ></el-table-column>
      <el-table-column label="是否允许存入">
        <template slot-scope="scope">
          <span v-if="scope.row.status">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="币种利率" type="expand" width="100">
        <template slot-scope="scope">
          <span
            v-for="item in Object.keys(scope.row.rateConfDto.rateConf)"
            :key="item"
          >
            <el-tag type="info" style="margin:0 5px 5px 0;"
              >{{ item }}天：{{
                parseInt(scope.row.rateConfDto.rateConf[item] * 10000) / 100
              }}%</el-tag
            >
          </span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip content="修改">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="user-withdrawal-records-wrap">
      <el-dialog
        :visible.sync="showUserDialog"
        title="账户余额信息"
        width="1200px"
      >
        <withdraw-records
          v-if="showUserDialog"
          :uid="nowUserId"
        ></withdraw-records>
      </el-dialog>
    </div>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Detail from '../detail';
import WithdrawRecords from '../records';

export default {
  name: 'cornucopiaList',
  data() {
    return {
      showUserDialog: false
    };
  },
  computed: {
    ...mapState('cornucopia', ['projects'])
  },
  components: {
    Detail,
    WithdrawRecords
  },
  methods: {
    ...mapMutations('cornucopia', ['setEditingProject']),
    edit(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    getUserDetail(uid) {
      this.nowUserId = uid;
      this.showUserDialog = true;
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
